// extracted by mini-css-extract-plugin
export default {"card":"styles_card__Y4uHs","row":"styles_row__Dnyfu","item":"styles_item__EDxDp","label":"styles_label__EFYgT","amount":"styles_amount__PBR2b","unit":"styles_unit__d9I6L"};